import { doc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { getUserDatabase } from './getUserDatabase';

export async function updateFoodItemInDatabase(user, containerKey, itemId, updates) {
  if (!user?.uid || !containerKey || !itemId || !updates) {
    return null;
  }

  const userDatabase = await getUserDatabase(user);
  const containers = userDatabase?.containers ?? {};
  const containerItems = Array.isArray(containers[containerKey])
    ? containers[containerKey]
    : [];

  const nextDatabase = {
    ...userDatabase,
    containers: {
      ...containers,
      [containerKey]: containerItems.map((item) =>
        item.id === itemId
          ? {
              ...item,
              ...updates,
            }
          : item
      ),
    },
  };

  await setDoc(doc(db, 'users', user.uid), nextDatabase, { merge: true });

  return nextDatabase;
}
